import type { ReactNode } from 'react';
import { PieceIcon } from './Pieces';
import { settings, useStore } from '../lib/store';

/** Loading indicator: the frog hops on top of a spinning ring. */
export function Loader({ label, children, size = 'md' }: { label?: ReactNode; children?: ReactNode; size?: 'sm' | 'md' }) {
  const { pieceSet } = useStore(settings);
  return (
    <div className={`loader loader-${size}`} role="status" aria-live="polite">
      <div className="loader-art" aria-hidden="true">
        <span className="loader-frog"><PieceIcon icon="frog" color="w" set={pieceSet} /></span>
        <span className="loader-shadow" />
        <span className="loader-ring" />
      </div>
      {label && <div className="loader-label">{label}</div>}
      {children}
    </div>
  );
}

/** Full-area overlay version, e.g. while searching for an opponent. */
export function LoaderOverlay({ label, children }: { label: ReactNode; children?: ReactNode }) {
  return (
    <div className="loader-overlay">
      <div className="loader-card">
        <Loader label={label}>{children}</Loader>
      </div>
    </div>
  );
}
